(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/helpers/handlebarhelpers.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/helpers/handlebarhelpers.js'); 
'use strict';

if (svs.isServer) {
  registerHelpers(require('hbs'));
} else {
  registerHelpers(Handlebars);
}
function registerHelpers(hbs) {
  hbs.registerHelper('customizableHelper', function (helperFunction) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    const options = args.pop();
    let result;
    if (typeof helperFunction === 'function') {
      result = helperFunction(...args);
    }
    if (result && typeof options.fn === 'function') {
      return options.fn(this);
    }
    if (!result && typeof options.inverse === 'function') {
      return options.inverse(this);
    }
    return result;
  });
  hbs.registerHelper('includes', function (array, value, options) {
    const includes = Array.isArray(array) && array.indexOf(value) > -1;
    if (includes && typeof options.fn === 'function') {
      return options.fn(this);
    }
    if (!includes && typeof options.inverse === 'function') {
      return options.inverse(this);
    }
    return includes;
  });
  hbs.registerHelper('isFalse', function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    const options = args.pop();
    let i = args.length;
    while (i--) {
      if (args[i]) break;
    }
    if (i > -1) {
      return typeof options.inverse === 'function' ? options.inverse(this) : false;
    }
    return typeof options.fn === 'function' ? options.fn(this) : true;
  });
  hbs.registerHelper('drawDaysFormat', _ref => {
    let {
      first,
      last,
      weekday
    } = _ref;
    if (weekday) return weekday;
    let label = svs.utils.date.FormatTime('EEE d/M', first);
    if (last) label += "- ".concat(svs.utils.date.FormatTime('d/M', last));
    return label;
  });
}
 })(window);